<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="8">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('table_label_search')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot :form="form" />
          </b-input-group>
        </b-form>
      </b-col>
      <el-select
        size="mini"
        style="width: 200px;margin-right: 30px;"
        class="el-selct-date-range"
        @change="changeDateRange"
        v-model="form.dateRange"
        clearable
        :placeholder="
          $l('header_tips_select_data_range_placeholder') || '快速过滤'
        "
      >
        <el-option
          v-for="item in dateRangeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </b-row>
    <el-drawer
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      show-close
      :visible.sync="advqueryDialogVisible"
      size="500px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="ml-4 mr-4">
        <el-form
          ref="form"
          :model="form"
          size="mini"
          label-width="100px"
          label-position="top"
        >
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_amzPurchaseStatus') || '状态'"
              >
                <el-checkbox-group
                  size="mini"
                  v-model="form.listAmzPurchaseStatus"
                >
                  <el-checkbox label="N">
                    {{ $l('form_label_amzPurchaseStatus_N') || '草稿' }}
                  </el-checkbox>
                  <el-checkbox label="Y">
                    {{ $l('form_label_amzPurchaseStatus_Y') || '审核通过' }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_amzPurchaseNo') || '采购单号'"
              >
                <el-input
                  size="mini"
                  v-model="form.amzPurchaseNo"
                  :placeholder="
                    $l('header_tips_input_amzPurchaseNo_placeholder') ||
                      '请输入采购单号'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_goodsName') || '产品名称'">
                <el-input
                  v-model.trim="form.goodsName"
                  :placeholder="
                    $l('header_tips_input_goodsName_placeholder') ||
                      '请输入产品名称'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_amzSkuNo') || 'SKU'">
                <el-input
                  v-model="form.amzSkuNo"
                  :placeholder="
                    $l('header_tips_input_amzSkuNo_placeholder') ||
                      '请输入产品SKU'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_ncNo') || 'NC'">
                <el-input
                  v-model.trim="form.ncNo"
                  :placeholder="
                    $l('header_tips_input_NC_placeholder') || '请输入NC'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_goodsColor') || '颜色'">
                <el-input
                  v-model.trim="form.goodsColor"
                  :placeholder="
                    $l('header_form_label_goodsColor_placeholder') ||
                      '请输入颜色'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_scm') || '工厂'">
                <dict-select
                  v-model="form.listScmCode"
                  url="/master/common/dict/scmCooperated"
                  :placeholder="
                    $l('header_tips_select_scm_placeholder') || '请选择工厂'
                  "
                  size="mini"
                  style="width: 100%"
                  filterable
                  clearable
                  multiple
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-row :gutter="0">
                <el-form-item
                  :label="$l('form_label_purchaseDate') || '采购日期'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.purchaseDateStart"
                      type="date"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('tips_select_purchase_date_start') || '选择采购日期'
                      "
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.purchaseDateEnd"
                      type="date"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('tips_select_purchase_date_end') || '选择采购日期'
                      "
                      style="width: 100%"
                    />
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_buyer') || '采购人员'">
                <dict-select
                  v-model="form.listBuyerCode"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('header_placeholder_form_label_buyer') ||
                      '请选择采购人员'
                  "
                  size="mini"
                  style="width: 100%"
                  filterable
                  clearable
                  multiple
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_isAllShipments') || '是否出货完成'"
              >
                <el-checkbox-group
                  size="mini"
                  v-model="form.listIsAllShipments"
                >
                  <el-checkbox label="N">
                    {{ $l('form_label_isAllShipments_N') || '未出完' }}
                  </el-checkbox>
                  <el-checkbox label="Y">
                    {{ $l('form_label_isAllShipments_Y') || '已出完' }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_isShipmentsRecord') || '是否有出货记录'"
              >
                <el-checkbox-group
                  @change="changeShipmentsRecord"
                  size="mini"
                  v-model="form.listIsShipmentsRecord"
                >
                  <el-checkbox label="Y">
                    {{ $l('form_label_isShipmentsRecord_Y') || '有记录' }}
                  </el-checkbox>
                  <el-checkbox label="N">
                    {{ $l('form_label_isShipmentsRecord_N') || '无记录' }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_inventoryAction') || '库存处理方式'"
              >
                <dict-select
                  v-model="form.inventoryActionList"
                  url="/sys/common/dict/system"
                  :body="{ dictType: 'inventoryAction' }"
                  :placeholder="
                    $l('header_placeholder_select_inventoryAction') ||
                      '请选择库存处理方式'
                  "
                  size="mini"
                  style="width: 100%"
                  filterable
                  clearable
                  multiple
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-row :gutter="0">
                <el-form-item
                  :label="
                    $l('form_label_lastShipmentTime') || '最后一次出货时间'
                  "
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.lastShipmentTime"
                      type="date"
                      size="mini"
                      style="width: 100%"
                      value-format="yyyy-MM-dd"
                      :disabled="disabledChooseDate"
                      :picker-options="pickerOptions"
                      :placeholder="
                        $l('header_tips_select_lastShipmentTime') ||
                          '选择最后一次出货时间'
                      "
                      align="right"
                      @change="onChangeShipmentTime"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="currDate"
                      type="date"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      :disabled="disabledChooseDate"
                      readonly
                      style="width: 100%"
                    />
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_design') || '企划人员'">
                <dict-select
                  v-model="form.listDesignCode"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('header_placeholder_form_label_design') ||
                      '请选择企划人员'
                  "
                  size="mini"
                  style="width: 100%"
                  filterable
                  clearable
                  multiple
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_sku_buyer') || '运营人员'">
                <dict-select
                  v-model="form.listSkuBuyerCode"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('header_placeholder_form_label_sku_buyer') ||
                      '请选择运营人员'
                  "
                  size="mini"
                  style="width: 100%"
                  filterable
                  clearable
                  multiple
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-row :gutter="0">
                <el-form-item
                  :label="$l('form_label_deliveryDate') || '工厂订单交期'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.deliveryDateStart"
                      type="date"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('tips_select_delivery_date_start') ||
                          '选择工厂订单交期'
                      "
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.deliveryDateEnd"
                      type="date"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('tips_select_delivery_date_end') ||
                          '选择工厂订单交期'
                      "
                      style="width: 100%"
                    />
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
        <span class="footer mt-2">
          <el-button size="mini" @click="closeAdvqueryDialog">
            {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
          </el-button>
          <el-button size="mini" type="warning" @click="reset">
            {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
          </el-button>
          <el-button size="mini" type="primary" @click="advquery">
            {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
          </el-button>
        </span>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import dayjs from 'dayjs'
const initForm = {
  keyword: '',
  listAmzPurchaseStatus: ['Y'],
  listIsAllShipments: ['N'],
  listIsShipmentsRecord: ['N', 'Y'],
  inventoryActionList: ['Y'],
  lastShipmentTime: '',
  dateRange: 'Z',
}
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  data() {
    return {
      currDate: '',
      advqueryDialogVisible: false,
      form: { ...initForm, lastShipmentTime: '', dateRange: 'Z' },
      disabledChooseDate: false,
      dateRangeOptions: [
        {
          label: this.$l('btn_all_record') || '全部',
          value: 'Z',
          fun: () => {
            return ''
          },
        },
        {
          label:
            this.$l('btn_last_one_months_no_record') || '近一个月无出货记录',
          value: 'A',
          fun: () => {
            let end = dayjs()
            const start = end.subtract(1, 'month').toDate()
            return start
          },
        },
        {
          label:
            this.$l('btn_last_three_months_no_record') || '近三个月无出货记录',
          value: 'B',
          fun: () => {
            let end = dayjs()
            const start = end.subtract(3, 'month').toDate()
            return start
          },
        },
        {
          label: this.$l('btn_last_six_months_no_record') || '近半年无出货记录',
          value: 'C',
          fun: () => {
            let end = dayjs()
            const start = end.subtract(6, 'month').toDate()
            return start
          },
        },
        {
          label: this.$l('btn_last_year_no_record') || '近一年无出货记录',
          value: 'D',
          fun: () => {
            let end = dayjs()
            const start = end.subtract(1, 'year').toDate()
            return start
          },
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: this.$l('btn_last_one_months') || '最近一个月',
            onClick(picker) {
              let end = dayjs()
              const start = end.subtract(1, 'month').toDate()
              picker.$emit('pick', start)
            },
          },
          {
            text: this.$l('btn_last_three_months') || '最近三个月',
            onClick(picker) {
              let end = dayjs()
              const start = end.subtract(3, 'month').toDate()
              picker.$emit('pick', start)
            },
          },
          {
            text: this.$l('btn_last_six_months') || '最近半年',
            onClick(picker) {
              let end = dayjs()
              const start = end.subtract(6, 'month').toDate()
              picker.$emit('pick', start)
            },
          },
          {
            text: this.$l('btn_last_year') || '最近一年',
            onClick(picker) {
              let end = dayjs()
              const start = end.subtract(1, 'year').toDate()
              picker.$emit('pick', start)
            },
          },
        ],
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }

      const { listAmzPurchaseStatus } = this.form
      if (!listAmzPurchaseStatus?.length) {
        this.form = { ...this.form, listAmzPurchaseStatus: ['Y'] }
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.disabledChooseDate = false
      this.form.dateRange = ''
      this.currDate = ''
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    changeDateRange(val) {
      this.reset()
      this.form.dateRange = val
      if (val) {
        let dateRange = this.dateRangeOptions.filter((e) => e.value == val)
        if (dateRange && dateRange.length > 0) {
          this.form.lastShipmentTime = dateRange[0].fun()
          if (dateRange[0].fun()) {
            this.currDate = dayjs().toDate()
          } else {
            this.currDate = ''
          }
        }
      }
      this.query()
    },
    onChangeShipmentTime(val) {
      if (val) {
        this.currDate = dayjs().toDate()
      } else {
        this.currDate = ''
      }
    },
    changeShipmentsRecord(val) {
      if (val && val.includes('Y')) {
        this.disabledChooseDate = false
      } else {
        this.form.lastShipmentTime = ''
        this.currDate = ''
        this.disabledChooseDate = true
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px !important;
}
.line {
  text-align: center;
}
.footer {
  display: flex;
  justify-content: end;
}
::v-deep {
  .el-drawer__header {
    margin-bottom: 15px !important;
  }
}
</style>
